import { matchPath, useLocation } from 'react-router-dom'

import { generateCompanyURI } from 'sagas/helpers/generateCompanyURI'

export const useIsAllowedPath = () => {
    const { pathname } = useLocation()

    const isAllowedPath = (allowedPaths: string[]) => {
        return allowedPaths.some(
            (path) =>
                matchPath(pathname, {
                    path: generateCompanyURI(path),
                }) !== null,
        )
    }

    return { isAllowedPath }
}
